import { render, staticRenderFns } from "./PriceSettingsView.vue?vue&type=template&id=79046c97&scoped=true&"
import script from "./PriceSettingsView.vue?vue&type=script&lang=ts&"
export * from "./PriceSettingsView.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSettingsView.vue?vue&type=style&index=0&id=79046c97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79046c97",
  null
  
)

export default component.exports